module.exports = __webpack_public_path__ + "img/roadmap_icon_02@2x.723d6141.png";